<template>
  <div>
    <q-card class="col-12 marginTag">
      <q-card-section>
        <div class="itemDescriptionTitle">
          <div>
              <q-img
                contain
                :src="
                  require('@/assets/img/indicadorDescriptionIcon/info-black-24-dp-3.svg')
                "
              />
            </div>
          <div>
            <div class="titleCard">Descripción del indicador</div>
          </div>
        </div>

        <div v-if="descripcion !== null" class="itemDescription">
          <div>
            <q-img
              contain
              :src="
                require('@/assets/img/indicadorDescriptionIcon/help-black-24-dp.svg')
              "
            />
          </div>
          <div>
            <div class="titleDescription">Qué es</div>
            <div class="contentDescription">
              {{ descripcion }}
            </div>
          </div>
        </div>
        <div v-if="beneficio !== null" class="itemDescription">
          <div class="titleDescription">
            <q-img
              contain
              :src="
                require('@/assets/img/indicadorDescriptionIcon/verified-black-24-dp.svg')
              "
            />
          </div>
          <div>
            <div class="titleDescription">Beneficio</div>
            <div class="contentDescription">{{ beneficio }}</div>
          </div>
        </div>
        <div v-if="formula !== null" class="itemDescription">
          <div class="titleDescription">
            <q-img
              contain
              :src="
                require('@/assets/img/indicadorDescriptionIcon/calculate-black-24-dp.svg')
              "
            />
          </div>
          <div>
            <div class="titleDescription">Cómo se calcula</div>
            <div class="contentDescription">{{ formula }}</div>
          </div>
        </div>
        <div class="itemDescription">
          <div class="titleDescription">
            <q-img
              contain
              :src="
                require('@/assets/img/indicadorDescriptionIcon/watch-later-black-24-dp.svg')
              "
            />
          </div>
          <div>
            <div class="titleDescription">Periodicidad</div>
            <div class="contentDescription">
              {{ periodicidad }}
            </div>
          </div>
        </div>
        <div class="itemDescription">
          <div class="titleDescription">
            <q-img
              contain
              :src="
                require('@/assets/img/indicadorDescriptionIcon/fact-check-black-24-dp.svg')
              "
            />
          </div>
          <div>
            <div class="titleDescription">Fuente</div>
            <div class="contentDescription">{{ fuente }}</div>
          </div>
        </div>
        <div v-if="aclaraciones !== null" class="itemDescription">
          <div class="titleDescription">
            <q-img
              contain
              :src="
                require('@/assets/img/indicadorDescriptionIcon/note-add-black-24-dp.svg')
              "
            />
          </div>
          <div>
            <div class="titleDescription">Aclaraciones</div>
            <div class="contentDescription">{{ aclaraciones }}</div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { QImg } from 'quasar';

export default {
  components: {
    QImg
  },
  props: {
    dataIndicador: Object
  },
  data () {
    return {
      descripcion: '',
      beneficio: '',
      formula: '',
      periodicidad: '',
      fuente: '',
      aclaraciones: ''
    };
  },
  created () {
    this.refillData();
  },
  watch: {
    dataIndicador () {
      this.refillData();
    }
  },
  methods: {
    refillData () {
      this.descripcion = '';
      this.beneficio = '';
      this.formula = '';
      this.periodicidad = '';
      this.fuente = '';
      this.aclaraciones = '';
      if (this.dataIndicador.hasOwnProperty('descripcionDelIndicador')) {
        this.descripcion = this.dataIndicador.descripcionDelIndicador.hasOwnProperty('descripcion') ? this.dataIndicador.descripcionDelIndicador.descripcion : null;
        this.beneficio = this.dataIndicador.descripcionDelIndicador.hasOwnProperty('beneficio') ? this.dataIndicador.descripcionDelIndicador.beneficio : null;
        this.formula = this.dataIndicador.descripcionDelIndicador.hasOwnProperty('formula') ? this.dataIndicador.descripcionDelIndicador.formula : null;
        this.periodicidad = this.dataIndicador.descripcionDelIndicador.hasOwnProperty('periodicidad') ? this.dataIndicador.descripcionDelIndicador.periodicidad : this.dataIndicador.periodicidad;
        this.fuente = this.dataIndicador.descripcionDelIndicador.fuente;
        this.aclaraciones = this.dataIndicador.descripcionDelIndicador.hasOwnProperty('aclaraciones') ? this.dataIndicador.descripcionDelIndicador.aclaraciones : null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/*.q-card__section{
  display: grid !important;
}*/
.marginTag {
  margin-top: 25px;
}
.itemDescription, .itemDescriptionTitle {
  margin-bottom: 12px;
}
.itemDescriptionTitle {
  align-items: center;
  display: flex;
}
.titleDescription {
  font-family: DINPro;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.26px;
  color: #454545;
}
.titleDescription + div {
  font-family: DINPro;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.22px;
  color: #000;
}
.contentDescription {
  display: flex;
}
.q-img {
  width: 35px;
  margin-right: 10px;
  float: left;
}
.titleCard {
  font-weight: bold;
}
@media (max-width: 640px) {
  ::v-deep {
    .titleCard {
      margin-right: 0px;
    }
    .q-img {
      height: 26px;
      width: 26px;
    }
  }
}
</style>
